module.exports = __webpack_public_path__ + "img/IMG_0781.5af7662d.jpg";